// Import Actions
import { SET_INSTITUTIONS, SET_INSTITUTION_LOGO, SET_ACTIVE_INSTITUTION } from './InstitutionActions';
import { SET_IS_FETCHING } from '../App/AppActions';
import { LOGOUT_USER } from '../User/AuthActions';

// Initial State
export const initialState = {
    data: [],
    activeInstitution: null,
    isFetching: false,
};

const InstitutionReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_INSTITUTIONS:
            return {
                ...state,
                data: state.data.filter(existingInstitution => !action.institutions.find(institution => institution._id === existingInstitution._id)).concat(action.institutions),
                isFetching: false,
            };

        case SET_INSTITUTION_LOGO:
            return {
                ...state,
                data: state.data.map(institution => {
                    if(institution._id === action.institutionId) {
                        return {
                            ...institution,
                            logoUrl: action.logoUrl,
                        };
                    }
                    return institution;
                }),
            };

        case SET_ACTIVE_INSTITUTION:
            return {
                ...state,
                activeInstitution: action.institution,
            };

        case SET_IS_FETCHING:
            if(action.dataType === 'institutions') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default InstitutionReducer;
